import React, { useContext, useEffect, useState } from 'react';
import { Select, SelectProps } from 'formik-antd';
import { DictionnaryContext, DictionnarySelectItem } from '../../../utils/dictionnary';
import { AppState } from '../../../state/AppStateGate';

type Props = {
  dictionnarySelector: (context: DictionnaryContext) => Promise<DictionnarySelectItem[]>;
} & SelectProps;
const DictionnarySelect = (props: Props): React.ReactElement => {
  const [list, setList] = useState<Array<{ display: string; value: string }>>([]);
  const context = useContext(AppState);
  useEffect(() => {
    const loadList = async () => {
      const l = await props.dictionnarySelector({
        customerId: context.appState?.user?.profile?.customer[0],
      });
      setList(l);
    };
    loadList();
  }, []);
  return (
    <Select {...props}>
      {list.map((item: any): any => (<Select.Option key={item.value} value={item.value}>{item.display}</Select.Option>))}
    </Select>
  );
};

export default DictionnarySelect;
